<div
	class="close-position dropdown-content-root"
	(click)="$event.stopPropagation()"
>
	<div class="dropdown-title">
		<p class="title">{{ 'closePosition.title' | translate }}</p>
		<tui-icon
			class="icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>
	<div class="dropdown-content">
		@if (form) {
			<form
				class="form"
				[formGroup]="form"
				(ngSubmit)="onSubmit()"
			>
				<div class="form-fields">
					<div class="slider-wrapper">
						<div class="slider-inner">
							<h6 class="slider-title">{{ 'closePosition.positionSize' | translate }}</h6>
							<app-quantity-selector
								[position]="position()"
								[isCancelOpenedOrders]="form.get('cancel_open_orders')?.value"
								[isLoadingOrders]="isLoadingOrders()"
								(changeQty)="onChangeQty($event)"
							/>
						</div>
					</div>
					<div class="form-content">
						<div class="settings">
							<div class="settings-item">
								<app-order-type-select
									[control]="form.get('type')"
									[types]="orderTypesList"
								/>
							</div>
							<div class="settings-item">
								<app-order-term-select
									[control]="form.get('time_in_force')"
									[terms]="orderTermsList"
								/>
							</div>
							@if (isVisibleLimitPrice) {
								<app-order-price-input
									label="closePosition.price"
									[control]="form.get('limit_price')"
								/>
							}
						</div>
						<label class="label">
							<input
								size="m"
								tuiCheckbox
								type="checkbox"
								formControlName="cancel_open_orders"
								(change)="cancelOpenedOrders($event.target.checked)"
							/>
							{{ 'closePosition.cancelOpenedOrders' | translate }}
						</label>
						<app-button
							appearance="primary"
							size="l"
							[isDisabled]="isLoadingOrders()"
							[isLoading]="isClosePositionLoading()"
							(clicked)="isShowConfirmDialog ? onToggleConfirmDialog(true) : closePosition()"
						>
							{{ 'closePosition.confirmButton' | translate }}
						</app-button>
					</div>
				</div>
			</form>
		}
	</div>
</div>

<ng-template [(tuiDialog)]="isOpenConfirmDialog">
	<app-confirm-close-position
		(onConfirm)="closePosition()"
		[isLoading]="isClosePositionLoading()"
		(onCloseDialog)="onToggleConfirmDialog(false)"
	/>
</ng-template>
